<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.PanoniHeiBridge"></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.WhakaaweWhenuaHeiBridge"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaiFieldWaterSampling"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.WaiRaparapa"></app-basic-cartesian-chart>
